import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const TileViewBorderedGlyph = /*#__PURE__*/createElement("g", {
  id: "tile_view_bordered"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
  d: "M63.5,68.6h-44V15.5h44V68.6z M22.5,65.6h38V18.5h-38V65.6z"
})), /*#__PURE__*/createElement("rect", {
  x: "28.5",
  y: "26.5",
  className: "st9",
  width: "6.5",
  height: "7.5"
}), /*#__PURE__*/createElement("rect", {
  x: "38.5",
  y: "26.5",
  className: "st9",
  width: "6.5",
  height: "7.5"
}), /*#__PURE__*/createElement("rect", {
  x: "48.5",
  y: "26.5",
  className: "st9",
  width: "6.5",
  height: "7.5"
}), /*#__PURE__*/createElement("rect", {
  x: "28.5",
  y: "37.5",
  className: "st9",
  width: "6.5",
  height: "7.5"
}), /*#__PURE__*/createElement("rect", {
  x: "38.5",
  y: "37.5",
  className: "st9",
  width: "6.5",
  height: "7.5"
}));
const TileViewBordered = createSvg({
  name: 'tile_view_bordered',
  path: TileViewBorderedGlyph
});

export default TileViewBordered;
export { TileViewBorderedGlyph };
